<template lang="pug">
    v-main
        Header
        PasswordResetStep
        
</template>

<script>
import Header from "../components/SignupCard.vue";
import PasswordResetStep from "../components/PasswordResetStepCard.vue";
export default {
  components: {
    Header,
    PasswordResetStep
  }
};
</script>

